import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { useNavigate } from "react-router-dom";
import OrderWizard, { readWizard, clearWizard } from "@/OrderWizard";
import AdminPage from "@/AdminPage";
import MagnetixsLanding from "@/MagnetixsLanding";
import LegalPage from "@/LegalPage";
import { legalSnippets, inspirationItems, defaultSeo } from "@/content";

const Home = ({ topicSlug }) => {
  // Resume an in-progress order after a browser reload (state persisted in sessionStorage).
  const [started, setStarted] = useState(() => !!readWizard());
  const [bundle, setBundle] = useState(null);
  const navigate = useNavigate();
  const topic = topicSlug ? inspirationItems.find((t) => t.slug === topicSlug) : null;

  useEffect(() => {
    const seoTitle = topic ? topic.seoTitle : defaultSeo.title;
    const url = `https://www.magnetixs.de${topicSlug ? `/kuehlschrankmagnete/${topicSlug}` : "/"}`;
    document.title = seoTitle;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", topic ? topic.seoDescription : defaultSeo.description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", url);
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", seoTitle);
  }, [topic, topicSlug]);

  const start = (b = null) => {
    clearWizard();
    setBundle(b);
    setStarted(true);
    window.scrollTo(0, 0);
  };
  const exit = () => {
    clearWizard();
    setStarted(false);
    setBundle(null);
    window.scrollTo(0, 0);
  };

  return started ? (
    <OrderWizard initialBundle={bundle} onExit={exit} />
  ) : (
    <MagnetixsLanding onStart={start} onAdminClick={() => navigate("/admin")} heroDescription={topic?.text} />
  );
};

const TopicPage = () => {
  const { slug } = useParams();
  return <Home topicSlug={slug} />;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kuehlschrankmagnete/:slug" element={<TopicPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/impressum" element={<LegalPage title="Impressum" path="/impressum" snippetUrl={legalSnippets.impressum} />} />
          <Route path="/datenschutz" element={<LegalPage title="Datenschutzerklärung" path="/datenschutz" snippetUrl={legalSnippets.datenschutz} />} />
          <Route path="/agb" element={<LegalPage title="AGB" path="/agb" snippetUrl={legalSnippets.agb} />} />
          <Route path="/widerruf" element={<LegalPage title="Widerrufsbelehrung" path="/widerruf" snippetUrl={legalSnippets.widerruf} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
